import { Absent_getInstance17o8jlyfouexf as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePartyInputClass;
function SavePartyInput() {
  if (SavePartyInputClass === VOID) {
    class $ {
      constructor(partyId, name, email, pairingRule, badgesEnabled, defaultBadgeName, alternateBadgeName, callSignsEnabled, animationsEnabled, animationSpeed) {
        name = name === VOID ? Absent_getInstance() : name;
        email = email === VOID ? Absent_getInstance() : email;
        pairingRule = pairingRule === VOID ? Absent_getInstance() : pairingRule;
        badgesEnabled = badgesEnabled === VOID ? Absent_getInstance() : badgesEnabled;
        defaultBadgeName = defaultBadgeName === VOID ? Absent_getInstance() : defaultBadgeName;
        alternateBadgeName = alternateBadgeName === VOID ? Absent_getInstance() : alternateBadgeName;
        callSignsEnabled = callSignsEnabled === VOID ? Absent_getInstance() : callSignsEnabled;
        animationsEnabled = animationsEnabled === VOID ? Absent_getInstance() : animationsEnabled;
        animationSpeed = animationSpeed === VOID ? Absent_getInstance() : animationSpeed;
        this.q6r_1 = partyId;
        this.r6r_1 = name;
        this.s6r_1 = email;
        this.t6r_1 = pairingRule;
        this.u6r_1 = badgesEnabled;
        this.v6r_1 = defaultBadgeName;
        this.w6r_1 = alternateBadgeName;
        this.x6r_1 = callSignsEnabled;
        this.y6r_1 = animationsEnabled;
        this.z6r_1 = animationSpeed;
      }
      toString() {
        return 'SavePartyInput(partyId=' + this.q6r_1.toString() + ', name=' + toString(this.r6r_1) + ', email=' + toString(this.s6r_1) + ', pairingRule=' + toString(this.t6r_1) + ', badgesEnabled=' + toString(this.u6r_1) + ', defaultBadgeName=' + toString(this.v6r_1) + ', alternateBadgeName=' + toString(this.w6r_1) + ', callSignsEnabled=' + toString(this.x6r_1) + ', animationsEnabled=' + toString(this.y6r_1) + ', animationSpeed=' + toString(this.z6r_1) + ')';
      }
      hashCode() {
        var result = this.q6r_1.hashCode();
        result = imul(result, 31) + hashCode(this.r6r_1) | 0;
        result = imul(result, 31) + hashCode(this.s6r_1) | 0;
        result = imul(result, 31) + hashCode(this.t6r_1) | 0;
        result = imul(result, 31) + hashCode(this.u6r_1) | 0;
        result = imul(result, 31) + hashCode(this.v6r_1) | 0;
        result = imul(result, 31) + hashCode(this.w6r_1) | 0;
        result = imul(result, 31) + hashCode(this.x6r_1) | 0;
        result = imul(result, 31) + hashCode(this.y6r_1) | 0;
        result = imul(result, 31) + hashCode(this.z6r_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePartyInput()))
          return false;
        if (!this.q6r_1.equals(other.q6r_1))
          return false;
        if (!equals(this.r6r_1, other.r6r_1))
          return false;
        if (!equals(this.s6r_1, other.s6r_1))
          return false;
        if (!equals(this.t6r_1, other.t6r_1))
          return false;
        if (!equals(this.u6r_1, other.u6r_1))
          return false;
        if (!equals(this.v6r_1, other.v6r_1))
          return false;
        if (!equals(this.w6r_1, other.w6r_1))
          return false;
        if (!equals(this.x6r_1, other.x6r_1))
          return false;
        if (!equals(this.y6r_1, other.y6r_1))
          return false;
        if (!equals(this.z6r_1, other.z6r_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePartyInput');
    SavePartyInputClass = $;
  }
  return SavePartyInputClass;
}
//region block: exports
export {
  SavePartyInput as SavePartyInput3ikp23en56cie,
};
//endregion

//# sourceMappingURL=SavePartyInput.mjs.map
